import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbwb8tkmam: FaireProductEntity = {
  token: "p_bbwb8tkmam",
  type: "product",
  name: "Strengthen Shampoo Bar For Thinning or Damaged Hair",
  brandToken: "b_vufm7w6mfr",
  brandName: "BRIXY",
  imageUrl:
    "https://cdn.faire.com/fastly/d221b6ce8b2e376e4539c2bee14b086cefd4d82ffc6c7416e0cd16c454cafd08.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/348e21526804c65ddcca936a3769d1ad20f0ca398a8f20a2497332b343a5fcc2.png",
    "https://cdn.faire.com/fastly/235aea0108b2af0c494d94778c91ccb78dd945112b359fc9486c991970727d8e.png",
    "https://cdn.faire.com/fastly/84ff1859a799e383f873655e159c3da8d681559c088f8bb79fd72fbbdf115278.png",
    "https://cdn.faire.com/fastly/858f0d4903a978ea6f61cf8e95329f217cd4347321dace67ecb16d641c2bb647.png",
    "https://cdn.faire.com/fastly/5484736a861c37595a006d00340837f4c67175068fec7f5819a81370139f1901.png",
    "https://cdn.faire.com/fastly/aca6a826c3fc272489133b8b9b5435b4a7e4f5e736c15dff9a311d91dfd05595.png",
    "https://cdn.faire.com/fastly/5597a3217c893c38b8ab9647774c4fcaca9c44028271b01ff9ea1a85fab91f9a.png",
    "https://cdn.faire.com/fastly/8ed4be15c7f7bd0c953aa4188f1e6f85282b4630e72c71d9fd04db644b1520d7.jpeg",
    "https://cdn.faire.com/fastly/4ab418f05b87410653625223461b92fae0d84d93c0bf091068e3828a47485b67.jpeg",
    "https://cdn.faire.com/fastly/a0bd73cba9dc5c4dd2f2c79b0bb18781ca6c638fcbbb4535856f4ce85bb143b3.jpeg",
    "https://cdn.faire.com/fastly/297608caff22448f713f490b144361c144c7e6d8e6acddd469aab039e7c1cd35.jpeg",
    "https://cdn.faire.com/fastly/9bd6d11aa22897575055a5cba32ae1bd9c2b54a29d39679589938ecf0b9f9c36.jpeg",
    "https://cdn.faire.com/fastly/2eee0e3fcda1f7a9fbce6b0c3bde727cd438222c7abe1930961d74f01a953119.jpeg",
    "https://cdn.faire.com/fastly/4a66e271c1a741a71a058b179b0b3abf344a07b11873bc9a6645517f0359def4.jpeg",
  ],
  priceDollars: 7.99,
  description:
    "An award winning strengthening and stimulating shampoo bar that will make you forget about your old water-based shampoo in plastic bottles! ​\n\nFormulated with science backed ingredients like pumpkin seed oil, rosemary oil and caffeine that work to stimulate the scalp and encourage blood flow to the follicles. Designed to prevent hair loss and promote new growth. \n\nNext generation hair care that includes a ceramide and niacinamide complex. Ingredients clinically proven to enhance the moisture levels of skin and hair and protect against environmental stress that causes dryness, breakage, scalp irritation.​​\n\nBest for thinning or damaged hair​\npH balanced and color safe formula​​\nFree from soap, sulfates, silicones, phthalates, parabens, PEGs, and synthetic scents and colorants\nA subtle sweet and floral scent of almond blossom ",
  tags: [],
  msrpDollars: 15.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:06.278Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
